import { DateAdapter } from "@angular/material/core";
import { Component, Inject, Injector, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Validators } from "@angular/forms";
import { GenericComponent } from "@shared/components/generic.component";
import { PeriodDTO } from "@shared/models/period-dto";
import { ServiceRequestService } from "@core/services/service-request.service";

interface PropsType {
  previsionDate?: string;
  previsionPeriod?: string;
}

@Component({
  templateUrl: "./modal-edit-workshop-prevision-date.component.html",
  styleUrls: ["./modal-edit-workshop-prevision-date.component.scss"],
  standalone: false
})
export class ModalEditWorkshopPrevisionDateComponent
  extends GenericComponent
  implements OnInit
{
  form = this.fb.group({
    previsionDate: ["", Validators.required],
    period: ["", Validators.required]
  });

  periods: PeriodDTO[] = [];

  constructor(
    injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: PropsType,
    private matDialogRef: MatDialogRef<ModalEditWorkshopPrevisionDateComponent>,
    private dateAdapter: DateAdapter<any>,
    private serviceRequestService: ServiceRequestService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.dateAdapter.setLocale(this.translateService.currentLang.toLowerCase());
    this.listAllPeriod();

    const parsedPrevisionDate = this.parseAsLocalDate(this.data?.previsionDate);

    this.form.patchValue({
      previsionDate: parsedPrevisionDate || "",
      period: this.data?.previsionPeriod || ""
    });
  }

  private listAllPeriod(): void {
    this.serviceRequestService.listAllTypePeriod().subscribe(
      (periods) => {
        this.periods = periods;
      },
      (error) => {
        this.showErrorMessage(error, "Error to list periods");
      }
    );
  }

  closeDialog(isSubmitted: boolean): void {
    if (!isSubmitted) {
      this.matDialogRef.close(null);
      return;
    }

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const previsionDateControl = this.form.get("previsionDate")?.value as any;
    const period = this.form.get("period")?.value as string;
    const previsionDate = this.parseAsLocalDate(previsionDateControl);

    if (!previsionDate) {
      this.form.get("previsionDate")?.setErrors({ required: true });
      this.form.markAllAsTouched();
      return;
    }

    const payload = {
      previsionDate: this.toLocalDateString(previsionDate),
      period
    };

    this.matDialogRef.close(payload);
  }

  private toLocalDateString(date: Date): string {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  private parseAsLocalDate(value: any): Date | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date && !Number.isNaN(value.getTime())) {
      return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }

    if (typeof value === "string") {
      const dateOnlyMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (dateOnlyMatch) {
        const [, year, month, day] = dateOnlyMatch;
        return new Date(Number(year), Number(month) - 1, Number(day));
      }
    }

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
      return null;
    }

    return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
  }
}
